export const TOTAL_BUDGE_CONTAINER = 'total-box';
export const TOTAL_BUDGE_TEXT = 'total-text';
export const BASKET_CONTAINER = 'basket';
